import { render, staticRenderFns } from "./tracklist.vue?vue&type=template&id=3fc67a40&scoped=true"
import script from "./tracklist.vue?vue&type=script&setup=true&lang=js"
export * from "./tracklist.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tracklist.vue?vue&type=style&index=0&id=3fc67a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc67a40",
  null
  
)

export default component.exports